// Internationalization (i18n) translations
export const TRANSLATIONS = {
  th: {
    brandName: 'TasteTrace',
    tagline: 'ตามรอยรสชาติที่ใช่',
    search: 'ค้นหาร้านอาหาร...',
    all: 'ทั้งหมด',
    michelinGuide: 'มิชลิน ไกด์',
    viewOnMap: 'ดูบนแผนที่',
    navigate: 'นำทาง',
    noRestaurants: 'ไม่พบร้านอาหารในบริเวณนี้',
    addRestaurants: 'เสนอร้านโปรดของคุณให้เรารู้จัก',
    // Dietary
    dietary: 'โภชนาการ',
    currency: 'สกุลเงิน',
    language: 'ภาษา',
    selectCurrency: 'เลือกสกุลเงิน',
    selectLanguage: 'เลือกภาษา',
    vegan: 'มังสวิรัติ (Vegan)',
    halal: 'ฮาลาล (Halal)',
    glutenFree: 'ปราศจากกลูเตน',
    // Social
    share: 'แบ่งปัน',
    copyLink: 'คัดลอกลิงก์',
    linkCopied: 'คัดลอกลิงก์แล้ว',
    // Profile
    tasteProfile: 'รสชาติที่ชอบ',
    favorites: 'ร้านโปรด',
    // Gamification
    achievements: 'ความสำเร็จ',
    explorer: 'นักสำรวจ',
    foodie: 'นักชิมตัวยง',
    // Search
    searchPlaceholder: 'ค้นหาร้าน, ประเภทอาหาร...',
    noResults: 'ไม่พบร้านที่ค้นหา',
    // Recommendations
    recommended: 'แนะนำสำหรับคุณ',
    // Queue
    currentWait: 'เวลารอโดยประมาณ',
    bestTime: 'เวลาที่แนะนำ',
    live: 'สด',
    // Match
    findPartners: 'หาเพื่อนร่วมโต๊ะ',
    joinGroup: 'เข้าร่วม',
    // Route
    planTrip: 'จัดทริปตระเวนกิน',
    startTrip: 'เริ่มออกเดินทาง',
    // Welcome
    welcomeTitle: 'ยินดีต้อนรับสู่ TasteTrace',
    welcomeDesc: 'ค้นพบร้านอาหารรางวัลมิชลินและร้านเด็ดที่ซ่อนอยู่ทั่วไทย พร้อมฟีเจอร์ AI ที่จะช่วยให้การกินของคุณสนุกยิ่งขึ้น',
    startExploring: 'เริ่มสำรวจเลย',
    // Concept
    conceptTitle: 'วิสัยทัศน์ของเรา',
    conceptDesc: 'เราเชื่อว่าอาหารคือการเดินทาง TasteTrace จึงถูกสร้างขึ้นเพื่อเชื่อมโยงผู้คนเข้ากับรสชาติที่แท้จริง ผ่านเทคโนโลยีที่เข้าใจความต้องการของนักกินอย่างลึกซึ้ง',
    // Community & Reviews
    reviews: 'รีวิว',
    photos: 'รูปภาพ',
    menu: 'เมนู',
    overview: 'ภาพรวม',
    writeReview: 'เขียนรีวิว',
    allReviews: 'รีวิวทั้งหมด',
    noReviews: 'ยังไม่มีรีวิว',
    beFirstReview: 'เป็นคนแรกที่รีวิว',
    helpful: 'เป็นประโยชน์',
    report: 'รายงาน',
    verified: 'ยืนยันแล้ว',
    mostRecent: 'ล่าสุด',
    mostHelpful: 'เป็นประโยชน์มากที่สุด',
    highestRated: 'คะแนนสูงสุด',
    lowestRated: 'คะแนนต่ำสุด',
    loadMore: 'โหลดเพิ่มเติม',
    seeAll: 'ดูทั้งหมด',
    recentReviews: 'รีวิวล่าสุด',
    community: 'ชุมชน',
    mustTry: 'ต้องลอง',
    recommended: 'แนะนำ',
    credibility: 'ความน่าเชื่อถือ',
    highlights: 'จุดเด่น',
    considerations: 'ข้อควรพิจารณา',
    featuredIn: 'เคยอยู่ใน',
    signatureDishes: 'เมนูแนะนำ',
    aiSummary: 'สรุปโดย AI',
    // Rating categories
    foodQuality: 'คุณภาพอาหาร',
    service: 'การบริการ',
    atmosphere: 'บรรยากาศ',
    valueForMoney: 'ความคุ้มค่า',
    // Review form
    overallRating: 'คะแนนโดยรวม',
    reviewTitle: 'หัวข้อรีวิว',
    yourReview: 'รีวิวของคุณ',
    summarizeExperience: 'สรุปประสบการณ์ของคุณ...',
    shareExperience: 'เล่าประสบการณ์ของคุณให้คนอื่นฟัง...',
    dishesOrdered: 'เมนูที่สั่ง',
    addDish: 'เพิ่มเมนู',
    add: 'เพิ่ม',
    visitDate: 'วันที่ไป',
    submitReview: 'ส่งรีวิว',
    submitting: 'กำลังส่ง...',
    cancel: 'ยกเลิก',
    optional: 'ไม่บังคับ',
    maxPhotos: 'สูงสุด 5 รูป',
    readMore: 'อ่านเพิ่มเติม',
    showLess: 'แสดงน้อยลง',
    wantToVisit: 'อยากไป'
  },
  en: {
    brandName: 'TasteTrace',
    tagline: 'Trace the Taste',
    search: 'Search restaurants...',
    all: 'All',
    michelinGuide: 'Michelin Guide',
    viewOnMap: 'View on Map',
    navigate: 'Navigate',
    noRestaurants: 'No restaurants found in this area',
    addRestaurants: 'Suggest your favorite spot',
    dietary: 'Dietary',
    currency: 'Currency',
    language: 'Language',
    selectCurrency: 'Select Currency',
    selectLanguage: 'Select Language',
    vegan: 'Vegan',
    halal: 'Halal',
    glutenFree: 'Gluten-Free',
    share: 'Share',
    copyLink: 'Copy Link',
    linkCopied: 'Link Copied',
    tasteProfile: 'Taste Profile',
    favorites: 'Favorites',
    achievements: 'Achievements',
    explorer: 'Explorer',
    foodie: 'Foodie',
    searchPlaceholder: 'Search for restaurants, cuisines...',
    noResults: 'No matches found',
    recommended: 'Recommended for you',
    currentWait: 'Est. Wait Time',
    bestTime: 'Best Time to Visit',
    live: 'Live',
    findPartners: 'Find Dining Partners',
    joinGroup: 'Join',
    planTrip: 'Plan Food Trip',
    startTrip: 'Start Journey',
    welcomeTitle: 'Welcome to TasteTrace',
    welcomeDesc: 'Discover Michelin-awarded spots and hidden gems across Thailand. Enhanced with AI to make your culinary journey unforgettable.',
    startExploring: 'Start Exploring',
    conceptTitle: 'Our Vision',
    conceptDesc: 'We believe food is a journey. TasteTrace works to connect people with authentic flavors through technology that deeply understands the needs of food lovers.',
    // Community & Reviews
    reviews: 'Reviews',
    photos: 'Photos',
    menu: 'Menu',
    overview: 'Overview',
    writeReview: 'Write Review',
    allReviews: 'All Reviews',
    noReviews: 'No reviews yet',
    beFirstReview: 'Be the first to review',
    helpful: 'Helpful',
    report: 'Report',
    verified: 'Verified',
    mostRecent: 'Most Recent',
    mostHelpful: 'Most Helpful',
    highestRated: 'Highest Rated',
    lowestRated: 'Lowest Rated',
    loadMore: 'Load More',
    seeAll: 'See all',
    recentReviews: 'Recent Reviews',
    community: 'Community',
    mustTry: 'Must Try',
    recommended: 'Recommended',
    credibility: 'Credibility',
    highlights: 'Highlights',
    considerations: 'Considerations',
    featuredIn: 'Featured In',
    signatureDishes: 'Signature Dishes',
    aiSummary: 'AI Concise Summary',
    // Rating categories
    foodQuality: 'Food Quality',
    service: 'Service',
    atmosphere: 'Atmosphere',
    valueForMoney: 'Value for Money',
    // Review form
    overallRating: 'Overall Rating',
    reviewTitle: 'Review Title',
    yourReview: 'Your Review',
    summarizeExperience: 'Summarize your experience...',
    shareExperience: 'Share your experience with others...',
    dishesOrdered: 'Dishes Ordered',
    addDish: 'Add a dish',
    add: 'Add',
    visitDate: 'Visit Date',
    submitReview: 'Submit Review',
    submitting: 'Submitting...',
    cancel: 'Cancel',
    optional: 'Optional',
    maxPhotos: 'Max 5 photos',
    readMore: 'Read more',
    showLess: 'Show less',
    wantToVisit: 'Want to Visit'
  },
  de: {
    brandName: 'TasteTrace',
    tagline: 'Folge dem Geschmack',
    search: 'Restaurants suchen...',
    all: 'Alle',
    michelinGuide: 'Michelin Guide',
    viewOnMap: 'Auf Karte anzeigen',
    navigate: 'Navigieren',
    noRestaurants: 'Keine Restaurants in diesem Bereich',
    addRestaurants: 'Schlagen Sie Ihren Lieblingsort vor',
    dietary: 'Ernährung',
    currency: 'Währung',
    language: 'Sprache',
    selectCurrency: 'Währung wählen',
    selectLanguage: 'Sprache wählen',
    vegan: 'Vegan',
    halal: 'Halal',
    glutenFree: 'Glutenfrei',
    share: 'Teilen',
    copyLink: 'Link kopieren',
    linkCopied: 'Link kopiert',
    tasteProfile: 'Geschmacksprofil',
    favorites: 'Favoriten',
    achievements: 'Erfolge',
    explorer: 'Entdecker',
    foodie: 'Feinschmecker',
    searchPlaceholder: 'Suche nach Restaurants, Küchen...',
    noResults: 'Keine Treffer gefunden',
    recommended: 'Für dich empfohlen',
    currentWait: 'Geschätzte Wartezeit',
    bestTime: 'Beste Besuchszeit',
    live: 'Live',
    findPartners: 'Essenspartner finden',
    joinGroup: 'Beitreten',
    planTrip: 'Essensreise planen',
    startTrip: 'Reise beginnen',
    welcomeTitle: 'Willkommen bei TasteTrace',
    welcomeDesc: 'Entdecken Sie Michelin-prämierte Orte und verborgene Schätze in ganz Thailand. Verbessert mit KI, um Ihre kulinarische Reise unvergesslich zu machen.',
    startExploring: 'Erkundung starten',
    conceptTitle: 'Unsere Vision',
    conceptDesc: 'Wir glauben, Essen ist eine Reise. TasteTrace verbindet Menschen mit authentischen Geschmäckern durch Technologie, die die Bedürfnisse von Feinschmeckern versteht.',
    // Community & Reviews
    reviews: 'Bewertungen',
    photos: 'Fotos',
    menu: 'Speisekarte',
    overview: 'Übersicht',
    writeReview: 'Bewertung schreiben',
    allReviews: 'Alle Bewertungen',
    noReviews: 'Noch keine Bewertungen',
    beFirstReview: 'Schreiben Sie die erste Bewertung',
    helpful: 'Hilfreich',
    report: 'Melden',
    verified: 'Verifiziert',
    mostRecent: 'Neueste',
    mostHelpful: 'Am hilfreichsten',
    highestRated: 'Bestbewertet',
    lowestRated: 'Schlechtestbewertet',
    loadMore: 'Mehr laden',
    seeAll: 'Alle anzeigen',
    recentReviews: 'Aktuelle Bewertungen',
    community: 'Community',
    mustTry: 'Must Try',
    recommended: 'Empfohlen',
    credibility: 'Glaubwürdigkeit',
    highlights: 'Highlights',
    considerations: 'Überlegungen',
    featuredIn: 'Vorgestellt in',
    signatureDishes: 'Empfohlene Gerichte',
    aiSummary: 'KI-Zusammenfassung'
  },
  // Chinese Simplified
  'zh-CN': {
    brandName: 'TasteTrace',
    tagline: '追踪美味',
    search: '搜索餐厅...',
    all: '全部',
    michelinGuide: '米其林指南',
    viewOnMap: '在地图上查看',
    navigate: '导航',
    noRestaurants: '该区域没有找到餐厅',
    addRestaurants: '推荐您喜欢的餐厅',
    dietary: '饮食偏好',
    currency: '货币',
    language: '语言',
    selectCurrency: '选择货币',
    selectLanguage: '选择语言',
    vegan: '纯素',
    halal: '清真',
    glutenFree: '无麸质',
    share: '分享',
    copyLink: '复制链接',
    linkCopied: '链接已复制',
    favorites: '收藏',
    reviews: '评价',
    photos: '照片',
    menu: '菜单',
    overview: '概览',
    writeReview: '写评价',
    allReviews: '全部评价',
    noReviews: '暂无评价',
    beFirstReview: '成为第一个评价的人',
    helpful: '有帮助',
    report: '举报',
    verified: '已验证',
    mostRecent: '最新',
    mostHelpful: '最有帮助',
    highestRated: '最高评分',
    lowestRated: '最低评分',
    loadMore: '加载更多',
    seeAll: '查看全部',
    community: '社区',
    mustTry: '必尝',
    recommended: '推荐',
    credibility: '可信度',
    highlights: '亮点',
    considerations: '注意事项',
    featuredIn: '特色推荐',
    signatureDishes: '招牌菜',
    wantToVisit: '想去'
  },
  // Japanese
  ja: {
    brandName: 'TasteTrace',
    tagline: '味を追いかけて',
    search: 'レストランを検索...',
    all: 'すべて',
    michelinGuide: 'ミシュランガイド',
    viewOnMap: '地図で見る',
    navigate: 'ナビゲート',
    noRestaurants: 'このエリアにレストランが見つかりません',
    addRestaurants: 'お気に入りのお店を提案',
    dietary: '食事制限',
    currency: '通貨',
    language: '言語',
    selectCurrency: '通貨を選択',
    selectLanguage: '言語を選択',
    vegan: 'ヴィーガン',
    halal: 'ハラール',
    glutenFree: 'グルテンフリー',
    share: 'シェア',
    copyLink: 'リンクをコピー',
    linkCopied: 'リンクをコピーしました',
    favorites: 'お気に入り',
    reviews: 'レビュー',
    photos: '写真',
    menu: 'メニュー',
    overview: '概要',
    writeReview: 'レビューを書く',
    allReviews: 'すべてのレビュー',
    noReviews: 'レビューはまだありません',
    beFirstReview: '最初のレビューを書く',
    helpful: '役に立った',
    report: '報告',
    verified: '認証済み',
    mostRecent: '最新',
    mostHelpful: '最も役立つ',
    highestRated: '評価が高い',
    lowestRated: '評価が低い',
    loadMore: 'もっと見る',
    seeAll: 'すべて見る',
    community: 'コミュニティ',
    mustTry: '必食',
    recommended: 'おすすめ',
    credibility: '信頼性',
    highlights: 'ハイライト',
    considerations: '注意点',
    featuredIn: '掲載',
    signatureDishes: '看板料理',
    wantToVisit: '行きたい'
  },
  // Korean
  ko: {
    brandName: 'TasteTrace',
    tagline: '맛을 따라서',
    search: '레스토랑 검색...',
    all: '전체',
    michelinGuide: '미쉐린 가이드',
    viewOnMap: '지도에서 보기',
    navigate: '내비게이션',
    noRestaurants: '이 지역에 레스토랑이 없습니다',
    addRestaurants: '좋아하는 맛집 추천하기',
    dietary: '식사 선호',
    currency: '통화',
    language: '언어',
    selectCurrency: '통화 선택',
    selectLanguage: '언어 선택',
    vegan: '비건',
    halal: '할랄',
    glutenFree: '글루텐 프리',
    share: '공유',
    copyLink: '링크 복사',
    linkCopied: '링크가 복사되었습니다',
    favorites: '즐겨찾기',
    reviews: '리뷰',
    photos: '사진',
    menu: '메뉴',
    overview: '개요',
    writeReview: '리뷰 쓰기',
    allReviews: '모든 리뷰',
    noReviews: '아직 리뷰가 없습니다',
    beFirstReview: '첫 번째 리뷰를 작성하세요',
    helpful: '도움이 됨',
    report: '신고',
    verified: '인증됨',
    mostRecent: '최신순',
    mostHelpful: '가장 도움이 됨',
    highestRated: '평점 높은순',
    lowestRated: '평점 낮은순',
    loadMore: '더 보기',
    seeAll: '전체 보기',
    community: '커뮤니티',
    mustTry: '필수',
    recommended: '추천',
    credibility: '신뢰도',
    highlights: '장점',
    considerations: '고려사항',
    featuredIn: '소개',
    signatureDishes: '대표 메뉴',
    wantToVisit: '가고 싶다'
  }
};

export const getTranslation = (lang) => {
  return (key) => {
    return TRANSLATIONS[lang]?.[key] || TRANSLATIONS['en']?.[key] || key;
  };
};
